import gql from 'graphql-tag';

export const qaMutation = gql`
  mutation SnapQa($input: SnapQaInput!) {
    snapQa(input: $input) {
      images {
        id
        question
      }
    }
  }
`;
